import React from 'react'
import SelectInput, { OptionType } from '../SelectInput'

type Props = {
  options: OptionType[]
  onChange: (id: string) => void
  value: string
}
const TabSelectBox: React.FC<Props> = ({ options, onChange, value }) => {
  return (
    <SelectInput
      isMulti={false}
      name='tab-select'
      options={options}
      onChange={onChange}
      value={options.find(option => option.value === value) ?? options[0] }
      hideSelectedOptions
      isSearchable={false}
      size='lg'
    />
  )
}

export default TabSelectBox
